<template>
  <div class="screen-main">
    <template v-if="isMoreLift">
      <div class="more-lift-box">
        <screen-monitor-item
          v-for="(item, index) in moreInfoStatusList"
          :key="index"
          :runData="item.runStatus"
          :infoData="item.infoData"
          :isSearch="index == 0"
          :screenWatch="screenWatch"
          @search="clickSearch"
          @click.native="entranceLift(item)"
        ></screen-monitor-item>
      </div>
    </template>
    <template v-else>
      <div class="main-left">
        <div class="run-quality-index">
          <div class="bsTitle">
            <h4 :text="$l('运行质量指数')">
              {{ $l("运行质量指数") }}
            </h4>
          </div>
          <div class="quality-view-box">
            <template v-if="runQualityGrade.remark">
              <div class="quality-index-box" id="quality-radar-id"></div>
              <div class="quality-grade-box">
                <div class="circle-box">
                  <screen-circle
                    :config="circleConfig"
                    :rate="runQualityGrade.score * 0.1"
                  >
                    <span>{{ runQualityGrade.score }}</span>
                  </screen-circle>
                </div>
                <i>{{ $l(runQualityGrade.remark) }}</i>
              </div>
            </template>
            <template v-else>
              <div class="not-data not-data-position">
                <p>
                  {{ runQualityLoading | emptyOrLoadText($l) }}
                </p>
              </div>
            </template>
          </div>
        </div>
        <div class="units-lifetime-forecast">
          <div class="bsTitle">
            <h4 :text="$l('部件寿命预测')">
              {{ $l("部件寿命预测") }}
            </h4>
          </div>
          <div class="ranking-list list-table row-n-1-n-1">
            <div class="list-title table-row">
              <div>{{ $l("排名") }}</div>
              <div>{{ $l("部件名称") }}</div>
              <!-- <div>剩余寿命</div> -->
              <div>{{ $l("检查日期") }}</div>
              <div class="div-els">
                {{ $l("部件等级") }}

                <el-tooltip
                  effect="dark"
                  content="Top Right 提示文字"
                  placement="top-end"
                  popper-class="units-explain"
                >
                  <div slot="content">
                    {{
                      $l(
                        "S级是重要部件，发生事故与故障的风险极高，需要尽早进行部件的更换",
                      )
                    }}
                    <br />
                    {{
                      $l(
                        "A级部件，发生事故和故障的风险很高，需要在一年之内进行部件的更换",
                      )
                    }}
                  </div>
                  <svgicon name="device_explain" />
                </el-tooltip>
              </div>
            </div>
            <template v-if="componentLifes.length != 0">
              <div
                class="table-row"
                v-for="(item, index) in componentLifes"
                :key="index"
              >
                <div>TOP{{ index + 1 }}</div>
                <div>{{ item.accessoriesName }}</div>
                <!-- <div>{{ item.lifeRatio | progressDecimals }}</div> -->
                <div>{{ item.predictionChangeDate }}</div>
                <div :class="`level-${item.itemGrade}`">
                  {{ item.itemGrade }}{{ $l("级") }}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="component-life-list">
                <div class="not-data">
                  <p>
                    {{
                      componentLifeLoading
                        ? $l("加载中...")
                        : $l("无计划更换部件请与维保单位确认。")
                    }}
                  </p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="run-degree-line">
          <div class="bsTitle">
            <h4 :text="$l('月度运行频率')">
              {{ $l("月度运行频率") }}
            </h4>
            <span class="bsTitle-extra">{{ $l("单位：次") }}</span>
          </div>
          <div class="degree-line-box">
            <div class="custom-legend-box">
              <div v-for="(item, index) in runFrequencyLabels" :key="index">
                <span :data-color="item.level">
                  <i></i>
                  <label>{{ $l(item.frequency) }}</label>
                </span>
              </div>
            </div>
            <div id="run-degree-id"></div>
            <div class="not-data not-data-position" v-if="!degreeLineChart">
              {{ runFrequencyLoading | emptyOrLoadText($l) }}
            </div>
          </div>
        </div>
        <div class="lift-nearby-crew">
          <div class="bsTitle">
            <h4 :text="$l('电梯附近人员')">
              {{ $l("电梯附近人员") }}
            </h4>
          </div>
          <div class="location-map">
            <div id="location-map-box" :key="mapKey">
              <div class="not-data">
                <p>
                  {{
                    baiduAK
                      ? locationLoading
                        ? $l("加载中...")
                        : $l("电梯坐标未采集，请联系维保单位确认。")
                      : $l("地图维护中...")
                  }}
                </p>
              </div>
            </div>
            <div class="crew-list">
              <template v-if="personnelData.length != 0">
                <div v-for="item in personnelData" :key="item.userId">
                  <span>{{ $l("姓名：") }} {{ item.userName }}</span>
                  <span>
                    {{ $l("距离：") }}
                    <em>{{ item.distance }}</em> {{ $l("米") }}
                  </span>
                </div>
              </template>
              <template v-else>
                <div>
                  <span>{{ $l("暂无人员数据") }} </span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="main-center">
        <div class="lift-view-box">
          <div
            :class="['lift-run-area', doorClass]"
            v-if="liftInfo.elevatorType == '直梯'"
          >
            <div class="btn-floor-box">
              <div
                class="direction"
                :class="
                  liftInfo.RunDirection == 1
                    ? 'floor-up'
                    : liftInfo.RunDirection == 2
                    ? 'floor-below'
                    : ''
                "
              >
                <span>{{ liftInfo | realFloor }}</span>
              </div>
              <div class="weight">
                <span>{{ $l("载重比") }} </span>
                <span>{{ liftInfo.Carry }}%</span>
              </div>
            </div>
            <div class="locf-door" v-if="isFault('电梯关门故障')"></div>
            <div class="locf-fault" v-if="isFault('困人故障')"></div>
            <div class="text-fault" v-if="isFault('困人故障')">
              <div class="tiring">
                <span>
                  <svgicon name="tiring" />
                </span>
                <label>{{ $l("困人故障") }} </label>
              </div>
            </div>
            <div class="text-unusual" v-if="isFault('开关门异常')">
              <div class="warning">
                <span>
                  <svgicon name="warning" />
                </span>
                <label>{{ $l("开关门异常") }} </label>
              </div>
            </div>
            <div class="text-door" v-if="isFault('电梯关门故障')">
              <div class="warning">
                <span>
                  <svgicon name="warning" />
                </span>
                <label>{{ $l("电梯关门故障") }} </label>
              </div>
            </div>
            <div class="thermometer-box" v-if="liftInfo.tavg">
              <svgicon name="thermometer" />
              <span>{{ $l("控制柜温度：") }} {{ liftInfo.tavg }}℃</span>
            </div>
          </div>
          <div class="lift-escalator-box" v-else>
            <div
              class="btn-direction"
              :class="
                liftInfo.RunDirection == 1
                  ? 'direction-up'
                  : liftInfo.RunDirection == 2
                  ? 'direction-below'
                  : ''
              "
            ></div>
            <div class="escalator-locf-fault" v-if="isFault('故障')"></div>
            <div class="escalator-fault-text" v-if="isFault('故障')">
              <div class="tiring">
                <span>
                  <svgicon name="tiring" />
                </span>
                <label>{{ $l("故障") }} </label>
              </div>
            </div>
          </div>
          <div class="lift-status-info">
            <!-- <div class="tip tip-plus">
              <p>{{ $l("电梯状态信息") }}</p>
            </div> -->
            <div class="lift-status-info-title">
              <div class="title-tips">
                <span>{{ $l("电梯状态信息") }}</span>
                <div class="searchBtn">
                  <i @click="handleSearch"></i>
                </div>
              </div>
              <h4>
                {{
                  (liftInfo.domainName || "") +
                    (liftInfo.buildingName || "") +
                    (liftInfo.elevatorNum || "") || ""
                }}
              </h4>
              <p>
                <label>{{ $l("出厂编号：") }} </label>
                <span @click="clickSearch">{{ liftInfo.jobNum }}</span>
              </p>
            </div>
            <div class="title-bgc-list-box">
              <div class="list">
                <div>
                  <label>{{ $l("运行模式：") }} </label>
                  <span
                    :class="
                      statusValue('运行ACD') &&
                      statusValue('运行ACD').includes('正常')
                        ? 'normal'
                        : 'not-normal'
                    "
                    >{{ $l(statusValue("运行ACD")) }}</span
                  >
                </div>
                <div>
                  <label>{{ $l("运行次数：") }} </label>
                  <span>{{ statusValue("运行次数") }}{{ $l("次") }}</span>
                </div>
                <div>
                  <label>{{ $l("运行速度：") }} </label>
                  <span class="speed">{{
                    statusValue("速度（米/分）") | formatDuring("米/分", $l)
                  }}</span>
                </div>
                <div>
                  <label>{{ $l("运行时长：") }} </label>
                  <span>{{
                    statusValue("运行时间（分）") | formatDuring("分", $l)
                  }}</span>
                </div>
                <div>
                  <label>{{ $l("梯龄：") }} </label>
                  <span>{{ liftInfo.elevatorAge }}{{ $l("年") }} </span>
                </div>
                <div>
                  <label>{{ $l("城市：") }} </label>
                  <span>{{ liftInfo.city }}</span>
                </div>
                <div>
                  <label>{{ $l("品牌：") }} </label>
                  <span>{{ $l(liftInfo.brand) }}</span>
                </div>
                <div>
                  <label>{{ $l("注册代码：") }} </label>
                  <span>{{ liftInfo.registerCode }}</span>
                </div>
                <div v-if="liftInfo.elevatorType == '直梯'">
                  <label>{{ $l("高频开关门楼层：") }} </label>
                  <span>{{ liftInfo.floors }}</span>
                </div>
                <div v-if="liftInfo.elevatorType == '直梯'">
                  <p class="suggest">
                    ({{
                      $l("建议加强保养该楼层的按钮、门锁、踏板、光幕等部件")
                    }})
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="maintenance-record">
          <div>
            <div class="bsTitle">
              <h4 :text="$l('上一次已完成的保养记录')">
                {{ $l("上一次已完成的保养记录") }}
              </h4>
            </div>
            <div class="ranking-list list-table row-1-1-n-1">
              <div class="list-title table-row">
                <div>{{ $l("实际作业时间") }}</div>
                <div>{{ $l("作业类型") }}</div>
                <div>{{ $l("实际作业人员") }}</div>
                <div>{{ $l("拍照图片") }}</div>
              </div>
              <div class="table-row">
                <div>{{ mainPlanRecord.last.actualStartDt }}</div>
                <div>{{ mainPlanRecord.last.planType }}</div>
                <div>{{ mainPlanRecord.last.workEmpNames }}</div>
                <div
                  class="view-img"
                  @click="getImageIdInfos"
                  v-if="mainPlanRecord.last.mpId"
                >
                  {{ $l("点击查看") }}
                </div>
                <div v-else></div>
              </div>
            </div>
          </div>
          <div>
            <div class="bsTitle">
              <h4 :text="$l('下一次已计划的保养记录')">
                {{ $l("下一次已计划的保养记录") }}
              </h4>
            </div>
            <div class="ranking-list list-table row-1-1-n-1">
              <div class="list-title table-row">
                <div>{{ $l("计划作业时间") }}</div>
                <div>{{ $l("作业类型") }}</div>
                <div>{{ $l("计划作业人员") }}</div>
              </div>
              <div class="table-row">
                <div>{{ mainPlanRecord.next.planStartDt }}</div>
                <div>{{ mainPlanRecord.next.planType }}</div>
                <div>{{ mainPlanRecord.next.planEmpNames }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="lift-run-fault-info">
          <div class="run-status-box">
            <div class="bsTitle">
              <h4 :text="$l('运行状态')">
                {{ $l("运行状态") }}
              </h4>
            </div>
            <div class="status-list">
              <div
                class="row-item"
                v-for="(item, index) in runStatusData"
                :key="index"
              >
                <div
                  :class="{
                    'activate-run': el.value == 1,
                    'run-red': runRedNames.includes(el.name),
                  }"
                  v-for="el in item"
                  :key="el.name"
                >
                  <i></i>
                  <span :title="$l(el.name)">{{ $l(el.name) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="run-status-box">
            <div class="bsTitle">
              <h4 :text="$l('故障状态')">
                {{ $l("故障状态") }}
              </h4>
            </div>
            <div class="status-list">
              <div
                class="row-item"
                v-for="(item, index) in faultStatusData"
                :key="index"
              >
                <div
                  :class="{ 'activate-fault': el.value == 1 }"
                  v-for="el in item"
                  :key="el.name"
                >
                  <i></i>
                  <span :title="$l(el.name)">{{ $l(el.name) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="video-monitoring">
          <div class="bsTitle">
            <h4 :text="videoType ? $l('安全乘梯小课堂') : $l('AI视频监控')">
              {{ videoType ? $l("安全乘梯小课堂") : $l("AI视频监控") }}
            </h4>
            <span class="bsTitle-extra lar-change" @click="changeVideo">
              <svgicon name="lar-change" />
            </span>
          </div>
          <div
            class="play-box"
            id="video-play-box"
            :key="videoPlayerKey"
            @dblclick="fullscreen()"
          >
            <template v-if="videoType">
              <video
                width="100%"
                controls
                autoplay
                muted
                id="video_h"
                @ended="handleEndEd"
                loop
              >
                <source :src="safetyVideoUrl" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
            </template>
            <template v-else>
              <video
                id="video"
                ref="video"
                width="100%"
                height="100%"
                disablePictureInPicture
                disableRemotePlayback
                controls
                muted
                autoplay
                v-if="liftInfo.deviceType == 4"
              ></video>
              <div id="play-box-id" v-else></div>
              <div class="not-data not-data-position" v-if="!videoPlayer">
                {{
                  videoLoading
                    ? $l("加载中...")
                    : $l("未安装或设置AI摄像头，请联系维保单位确认。")
                }}
              </div>
            </template>
          </div>
        </div>
        <div class="recently-service">
          <div class="bsTitle">
            <h4 :text="$l('最近故障维修记录')">
              {{ $l("最近故障维修记录") }}
            </h4>
          </div>
          <div class="ranking-list">
            <div class="list-title">
              {{ faultRecord.text }}
            </div>
            <!-- <div v-show="faultRecord.date"> -->
            <div>
              <span>{{ faultRecord.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <el-image-viewer
      v-screen-loading="imgLoading"
      v-if="showViewer"
      :zIndex="8000"
      :on-close="closeViewer"
      :on-switch="switchViewer"
      :url-list="previewImgList"
      :initial-index="preIniIndex"
    />
    <bindElevatorDialog
      class="screenStyle"
      pageClass="screenPage"
      ref="bindElevatorDialog"
      @selected="liftSelected"
    ></bindElevatorDialog>
  </div>
</template>

<script>
import "../../plugins/directive.js";
import dayjs from "dayjs";
import global from "@/mixins/global.js";
import screenCircle from "../../components/screenCircle.vue";
import MySeamlessScroll from "../../components/mySeamlessScroll.vue";
import * as echarts from "echarts";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import EZUIKit from "ezuikit-js";
import bindElevatorDialog from "@/components/bindElevatorDialog.vue";
import screenMonitorItem from "@/components/screenMonitorItem.vue";
import CanvasKeyFrames from "../../plugins/canvas-keyframes";
import loadBMap from "@/utils/loadBMap";
export default {
  name: "largeScreen",
  mixins: [global],
  inject: ["$pageLoading"],
  props: {
    screenWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      circleConfig: {
        borderWidth: "0.4vw",
        circleSize: "0",
        startColor: "#8AE4EF",
        endColor: "#4169F4",
        centerCircleBg: "#121a44",
        borderBackground: "rgba(156, 167, 239, 0.2)",
      },
      qualityRadarChart: null,
      degreeLineChart: null,
      locationData: { lng: null, lat: null },
      mapExample: null,
      showInput: false,
      jobNumValue: null,
      liftInfo: { jobNum: null, elevatorType: "直梯", DoorState: null },
      personnelData: [],
      locationLoading: false,
      faultStatusData: [],
      runStatusData: [],
      otherStatusData: [],
      runFrequencyData: [],
      runFrequencyLabels: [],
      runFrequencyLoading: false,
      mapKey: Date.now(),
      mainPlanRecord: { last: {}, next: {} },
      mainPlanImageIds: [],
      preIniIndex: 0,
      showViewer: false,
      previewImgList: [],
      imgLoading: false,
      videoPlayer: null,
      videoToken: null,
      videoUrl: null,
      videoLoading: false,
      videoPlayerKey: Date.now(),
      throttleTimer: null,
      faultRecord: { text: "", date: null },
      componentLifes: [],
      componentLifeLoading: false,
      runQualityLoading: false,
      runQualityData: [],
      runQualityGrade: { remark: null, score: 0 },
      isMoreLift: false,
      moreInfoStatusList: [],
      runRedNames: ["硬件安全回路", "软件安全回路", "轿门锁", "厅门锁", "门区"],
      keyFrames: null,
      doorState: "",
      doorClass: "",
      screenWatch: Date.now(),
      videoType: true,
      safetyVideoUrl: window.config.safetyVideoUrl,
      baiduAK: window.config.baiduAK,
    };
  },
  components: {
    screenCircle,
    MySeamlessScroll,
    ElImageViewer,
    bindElevatorDialog,
    screenMonitorItem,
  },
  computed: {
    isFault() {
      return (name) => {
        let arr = this.faultStatusData.flat(Infinity);
        let index = arr.findIndex((v) => v.name == name);
        if (index == -1) return false;
        return arr[index].value == 1;
      };
    },
    statusValue() {
      return (name) => {
        let arr = this.runStatusData.flat(Infinity);
        arr = arr.concat(this.otherStatusData);
        let index = arr.findIndex((v) => v.name == name);
        if (index == -1) return "";
        return arr[index].value;
      };
    },
  },
  filters: {
    progressDecimals(decimals) {
      return Math.floor(decimals * 100) + "%";
    },
    emptyOrLoadText(load, $l) {
      return load ? $l("加载中...") : $l("暂无数据");
    },
    formatDuring(millisecond, unit, $l) {
      millisecond = millisecond || 0;
      return isNaN(millisecond * 1) ? millisecond : millisecond + $l(unit);
      // return Math.floor(millisecond / 60) + "小时" + (millisecond % 60) + "分";
    },
    realFloor(elevator) {
      const floor = elevator.Floor;
      if (!floor || floor == "0") {
        return " ";
      }
      const realFloorList = elevator.realFloorList;
      if (realFloorList != null && realFloorList.length > 0) {
        for (let i = 0; i < realFloorList.length; i++) {
          const item = realFloorList[i];
          if (item.floorcode == floor) {
            return item.description + "F";
          }
        }
      }
      return floor + "F";
    },
  },
  watch: {
    "liftInfo.DoorState"() {
      if (this.liftInfo.elevatorType != "直梯") return false;
      const { DoorState } = this.liftInfo;
      if (DoorState == "open") {
        this.playDoorAnimation("open");
        this.doorClass = "none-class";
      } else if (DoorState == "close") {
        this.playDoorAnimation("close");
        this.doorClass = "none-class";
      } else {
        this.doorClass = null;
      }
    },
    "liftInfo.RunDirection"() {
      if (this.liftInfo.elevatorType == "直梯") return false;
      const { RunDirection } = this.liftInfo;
      if (RunDirection == 1) {
        this.playDoorAnimation("open");
        this.doorClass = "none-class";
      } else if (RunDirection == 2) {
        this.playDoorAnimation("close");
        this.doorClass = "none-class";
      } else {
        this.doorClass = null;
      }
    },
  },
  created() {},
  mounted() {
    this.getSpecialUser();
    if (this.$store.state.allDayMonitorTimer == -1) {
      this.$store.state.allDayMonitorTimer = null;
    }
    this.allowMonitor();
    this.initData();
    // this.playDoorAnimation(null);
  },
  methods: {
    getSpecialUser(){
       const user = this.getSpecialUserInfo();
       if(user) {
          this.safetyVideoUrl = user.videoUrl;
       }
       return user;
    },
    handleEndEd() {
      console.log(";结束");
      // const video = document.getElementById("video_h");
      // video && video.play();
    },
    changeVideo() {
      this.videoPlayerKey = Date.now();
      this.videoType = !this.videoType;
      this.$nextTick(() => {
        // !this.videoType && this.setVideoPlay();
        if (this.videoType) {
          const video = document.getElementById("video_h");
          video.play();
        } else {
          if (this.liftInfo.deviceType == 4) {
            this.flvPlay();
          } else {
            this.playElevatorVideo();
          }
        }
      });
    },
    initData() {
      const { jobNum } = this.$route.params;
      if (jobNum) {
        this.getElevatorForBigScreen(jobNum);
        delete this.$route.params.jobNum;
      } else this.getDefaultLiftInfo();
    },
    $browserWidthChange() {
      this.qualityRadarChart && this.setRunQualityRadar(true);
      this.degreeLineChart && this.setRunDegreeLine(true);
      this.mapExample && this.setNearbyLocationMap();
      !this.videoType &&
        this.setVideoPlay(this.videoToken, this.videoUrl, true);
      this.screenWatch = Date.now();
      const { elevatorType, RunDirection, DoorState } = this.liftInfo;
      const isEscalator = elevatorType != "直梯";
      let state = isEscalator
        ? RunDirection == 1
          ? "open"
          : RunDirection == 2
          ? "close"
          : ""
        : DoorState;
      this.playDoorAnimation(state, true);
    },
    transformFontSize(fontsize) {
      const width = this.screenWidth;
      const ratio = width / 1920;
      return parseInt(fontsize * ratio);
    },
    // getFollowItemScrollHeight(type) {
    //   this.$nextTick(() => {
    //     let scroll = document.getElementsByClassName("realtime-info-item");
    //     if (scroll && scroll.length != 0 && [undefined, 1].includes(type)) {
    //       let height = scroll[0]?.getBoundingClientRect()?.height;
    //       this.singleRealtimeHeight = height;
    //       console.log("singleRealtimeHeight", this.singleRealtimeHeight);
    //     }
    //     let mapScroll = document.getElementsByClassName("warning-map-item");
    //     if (
    //       mapScroll &&
    //       mapScroll.length != 0 &&
    //       [undefined, 2].includes(type)
    //     ) {
    //       let heightScroll = mapScroll[0]?.getBoundingClientRect()?.height;
    //       this.singleMapHeight = heightScroll;
    //       console.log("singleMapHeight", this.singleMapHeight);
    //     }
    //   });
    // },
    setRunQualityRadar(resize) {
      let chartDom = document.getElementById("quality-radar-id");
      this.qualityRadarChart = echarts.init(chartDom);
      let indicator = [
        {
          text: this.$l("保养执行率"),
          max: 10,
        },
        {
          text: this.$l("应急救援效率"),
          max: 10,
        },
        {
          text: this.$l("物联网功能"),
          max: 10,
        },
        {
          text: this.$l("风险诊断"),
          max: 10,
        },
        {
          text: this.$l("机房温度"),
          max: 10,
        },
        {
          text: this.$l("配件寿命预测"),
          max: 10,
        },
      ];
      let dataArr = [
        {
          value: this.runQualityData,
          name: this.$l("运行质量指数"),
          itemStyle: {
            normal: {
              color: "#FFCE7F",
            },
          },
          lineStyle: {
            normal: {
              // lineStyle: {
              // color: "#62788f",
              width: this.transformFontSize(3),
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 0, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0,
                    color: "#827CFF",
                  },
                  {
                    offset: 1,
                    color: "#FFBDA0",
                  },
                ],
                // },
              },
              // shadowColor: '#4A99FF',
              // shadowBlur: 10,
            },
          },
          areaStyle: {
            normal: {
              // 单项区域填充样式
              color: {
                type: "linear",
                x: 0, //右
                y: 0, //下
                x2: 0, //左
                y2: 1, //上
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(104, 84, 255,0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255,160,160,0.8)",
                  },
                ],
                globalCoord: false,
              },
              opacity: 1, // 区域透明度
            },
          },
        },
      ];
      let option = {
        // backgroundColor: "#101736",
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top: 0,
          containLabel: true,
        },
        color: "#dea20b",
        tooltip: {
          //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
          confine: true,
          enterable: false, //鼠标是否可以移动到tooltip区域内
          extraCssText: "font-size:0.75rem;",
          backgroundColor: "rgba(11,34,66,0.76)",
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#CCD9FF",
              fontSize: this.transformFontSize(13),
              // letterSpacing: 10,
            },
          },
          indicator: indicator,
          nameGap: "5",
          radius: "65%",
          // center: ["50%", "55%"],
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: true,
            areaStyle: {
              // 分隔区域的样式设置。
              color: ["rgba(55, 85 ,134,0)", "rgba(55 ,85 ,134,0.2)"], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            },
          },
          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              color: "rgba(56,99,233,0.3)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#375586", // 分隔线颜色
              width: 1, // 分隔线线宽
            },
          },
        },
        series: [
          {
            type: "radar",
            symbolSize: this.transformFontSize(5),
            symbol: "circle",
            data: dataArr,
          },
        ],
      };
      option && this.qualityRadarChart.setOption(option);
      resize && this.qualityRadarChart.resize();
    },
    setRunDegreeLine(resize) {
      let chartDom = document.getElementById("run-degree-id");
      this.degreeLineChart = echarts.init(chartDom);
      let xData = this.runFrequencyData.map((v) => {
        return this.$l(dayjs(v.runmonth).month() + 1 + "月");
      });
      let shadeColors = ["#8AE4EF", "#87B9FF", "#FB5C5D"]; //运行等级颜色，偏低、正常、偏高
      let maxnum = 0;
      let data = this.runFrequencyData.map((v) => {
        if (v.runtimes > maxnum) maxnum = v.runtimes;
        return {
          value: v.runtimes,
          level: v.level,
        };
      });
      let uniqueArr = this.runFrequencyData.reduce(function (
        accumulator,
        current,
      ) {
        // 使用属性值作为键来进行去重
        let key = current.frequency;
        if (!accumulator[key]) {
          accumulator[key] = current;
        }
        return accumulator;
      },
      {});
      // 将去重后的对象转换回数组
      this.runFrequencyLabels = Object.values(uniqueArr);
      let average = maxnum / 4;
      let option = {
        grid: {
          top: "20%",
          bottom: "3%",
          left: "2%",
          right: "5%",
          containLabel: true,
        },
        // legend: {
        //   top: "0",
        //   left: "center",
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#37E7D3",
            },
          },
          extraCssText: "font-size:0.75rem;",
          backgroundColor: "rgba(11,24,66 , 0.76)",
        },
        xAxis: {
          boundaryGap: true, // 默认，坐标轴留白策略
          axisLine: {
            // 坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: "#3A4D96",
            },
          },
          axisLabel: {
            // 坐标轴刻度标签的相关设置
            textStyle: {
              color: "#CCD9FF",
              margin: 15,
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          data: xData,
        },
        yAxis: {
          splitNumber: 4,
          axisLine: {
            show: false,
          },
          axisLabel: {
            // 坐标轴刻度标签的相关设置
            show: true,
            textStyle: {
              color: "#CCD9FF",
              margin: 15,
              fontSize: this.transformFontSize(13),
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#375586",
              width: 1,
              type: "dashed",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "scatter",
            symbolSize: 6,
            itemStyle: {
              color: "#FF8736",
            },
            silent: true,
            tooltip: {
              show: false,
            },
            data: xData.map((v) => v.value),
          },
          {
            type: "line",
            zlevel: 2,
            symbolSize: 12,
            symbol: function (num, params) {
              let icon = "degreeLineBlueIcon";
              const { level } = params.data;
              icon =
                level > 1
                  ? "degreeLineRedIcon"
                  : level > 0
                  ? "degreeLineGreenIcon"
                  : icon;
              return `image://${require(`../../assets/img/largeScreen/${icon}.png`)}`;
            },
            // symbol:
            //   "path://M488 187.381L242.872 328.906a48 48 0 0 0-24 41.57v283.049a48 48 0 0 0 24 41.569L488 836.619a48 48 0 0 0 48 0l245.128-141.525a48 48 0 0 0 24-41.57V370.476a48 48 0 0 0-24-41.569L536 187.381a48 48 0 0 0-48 0z m32 27.713l245.128 141.525a16 16 0 0 1 8 13.856v283.05a16 16 0 0 1-8 13.856L520 808.906a16 16 0 0 1-16 0L258.872 667.381a16 16 0 0 1-8-13.856v-283.05a16 16 0 0 1 8-13.856L504 215.094a16 16 0 0 1 16 0z",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: " rgba(56,99,233,0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(149,170,233,0.00)",
                    },
                  ],
                  false,
                ),
              },
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1, //0
                x2: 0,
                y2: 0, //1
                colorStops: data.map((v, i) => {
                  return {
                    offset: 0.333 * i > 0.9 ? 1 : 0.333 * i,
                    // color: shadeColors[data[data.length - 1 - i].level],
                    color: shadeColors[v.level],
                  };
                }),
                // [
                //   {
                //     offset: 0,
                //     color: shadeColors[data[3].level],
                //   },
                //   {
                //     offset: 0.333,
                //     color: shadeColors[data[2].level],
                //   },
                //   {
                //     offset: 0.666,
                //     color: shadeColors[data[1].level],
                //   },
                //   {
                //     offset: 1,
                //     color: shadeColors[data[0].level],
                //   },
                // ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              color: function (params) {
                return shadeColors[params.data.level];
              },
              borderWidth: 1,
              // borderColor: "#FF8736",
            },
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#fff",
              },
            },
            data: data,
            // markLine: {
            //   symbol: "none",
            //   // symbolSize: [10, 20],
            //   // symbol: ["none", "rect"],
            //   label: {
            //     show: false,
            //   },
            //   silent: true,
            //   data: [
            //     {
            //       yAxis: average,
            //     },
            //     {
            //       yAxis: average * 2,
            //     },
            //     {
            //       yAxis: average * 3,
            //     },
            //     {
            //       yAxis: average * 4,
            //     },
            //   ],
            //   lineStyle: {
            //     width: 2,
            //     color: "#5F76BC",
            //   },
            // },
          },
        ],
      };
      option && this.degreeLineChart.setOption(option);
      resize && this.degreeLineChart.resize();
    },
    setNearbyLocationMap() {
      loadBMap().then((BMap) => {
        this.mapExample = new BMap.Map("location-map-box");
        this.mapExample.centerAndZoom(
          new BMap.Point(this.locationData.lng, this.locationData.lat),
          15,
        );
        let point = new BMap.Point(
          this.locationData.lng,
          this.locationData.lat,
        );
        let marker = new BMap.Marker(point);
        // this.mapExample.centerAndZoom(point, 15);
        this.mapExample.addOverlay(marker);
        let circle = new BMap.Circle(point, 500, {
          strokeWeight: 0,
          strokeColor: "transparent",
          fillOpacity: 1,
          fillColor: "#4dbaff4a",
        }); //创建圆
        this.mapExample.addOverlay(circle);
      });
    },
    clickSearch() {
      this.$refs.bindElevatorDialog.show(null, 3);
      // this.showInput = true;
      // this.jobNumValue = this.liftInfo.jobNum;
      // this.$nextTick(() => {
      //   this.$refs.jobNumInput.select();
      //   this.$refs.jobNumInput.focus();
      // });
    },
    searchBlur() {
      // this.showInput = false;
    },
    handleSearch() {
      this.$refs.bindElevatorDialog.show(null, 3);
      // if (!this.showInput) return this.clickSearch();
      // if (
      //   this.jobNumValue == null ||
      //   this.jobNumValue == this.liftInfo.jobNum
      // ) {
      //   this.showInput = false;
      //   return;
      // }
      // if (!this.jobNumValue) return this.$message("请输入电梯工号！");
      // this.getElevatorForBigScreen(this.jobNumValue);
    },
    //获取默认电梯
    getDefaultLiftInfo() {
      this.$pageLoading(true);
      const ssLift = sessionStorage.getItem("deviceBigScreenLift");
      if (JSON.parse(ssLift)) {
        // this.setLiftInfoData(JSON.parse(ssLift));
        // this.$pageLoading(false);
        this.getElevatorForBigScreen(JSON.parse(ssLift).jobNum);
        return;
      }
      this.$http
        .post(this.$apiConfig.search_monitor_elevator_map_url, {
          pageNum: 1,
          pageSize: 20,
        })
        .then((response) => {
          let result = response.data;
          this.$pageLoading(false);
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          if (data.single.length == 0) return;
          this.setLiftInfoData(data.single[0]);
        })
        .catch((error) => {
          this.$pageLoading(true);
          this.$sentry.captureException(error);
        });
    },
    setLiftInfoData(obj) {
      const { x, y } = obj;
      this.liftInfo = obj;
      this.locationData.lng = x;
      this.locationData.lat = y;
      this.monitorLiftRealData();
      if (this.baiduAK) {
        this.getPersonnelLocation();
      }
      this.getMonthlyRunFrequency();
      this.getMainPlanRecord();
      // this.getVideoUrlToken();
      this.getLastFaultRecord();
      this.getComponentLifePrediction();
      this.getRunQualityIndex();
    },
    //获取人员定位
    getPersonnelLocation() {
      this.personnelData = [];
      if (this.mapExample) this.mapKey = Date.now();
      this.mapExample = null;
      if (!this.locationData.lng) return false;
      this.locationLoading = true;
      this.$http
        .get(this.$apiConfig.get_personnel_position_url, {
          params: {
            longitude: this.locationData.lng,
            latitude: this.locationData.lat,
          },
        })
        .then((response) => {
          let result = response.data;
          this.locationLoading = false;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          this.personnelData = data;
          if (this.personnelData.length > 3) this.personnelData.length = 3;
          this.personnelData.forEach(
            (t) => (t.distance = t.distance.toFixed(0)),
          );
          this.setNearbyLocationMap();
        })
        .catch((error) => {
          this.locationLoading = false;
          this.$sentry.captureException(error);
        });
    },
    monitorLiftRealData() {
      this.breakLiftRealData();
      this.realMonitorBigScreen([this.liftInfo], false, (d) => {
        const data = JSON.parse(d);
        let [realData] = data;
        if (!realData.data || JSON.stringify(realData.data) == "{}") return;
        let canFaultStatus = realData.data.FaultStatus.filter((v) =>
          this.hasMonitorFieldPermission("fault#" + v.name),
        );
        let canRunStatus = realData.data.RunStatus.filter((v) =>
          this.hasMonitorFieldPermission("run#" + v.name),
        );
        let canOtherStatus = realData.data.OtherStatus.filter((v) =>
          this.hasMonitorFieldPermission("other#" + v.name),
        );
        this.faultStatusData = [];
        this.runStatusData = [];
        this.otherStatusData = [];
        for (let i = 0; i < canFaultStatus.length; i += 3) {
          this.faultStatusData.push(canFaultStatus.slice(i, i + 3));
        }
        for (let i = 0; i < canRunStatus.length; i += 3) {
          this.runStatusData.push(canRunStatus.slice(i, i + 3));
        }
        this.otherStatusData = canOtherStatus;
        this.liftInfo = Object.assign(realData, {
          data: null,
          jobNum: this.liftInfo.jobNum,
        });
      });
    },
    breakLiftRealData() {
      this.faultStatusData = [];
      this.runStatusData = [];
      this.otherStatusData = [];
      this.doorClass = "";
      this.doorState = "";
      if (this.$store.state.ws) {
        this.$store.state.isAutoCloseWS = false;
        this.$store.state.ws.close();
        this.$store.commit("setWS", null);
      }
      this.playDoorAnimation(null);
    },
    //获取月度运行频率
    getMonthlyRunFrequency() {
      this.runFrequencyData = [];
      this.runFrequencyLabels = [];
      this.degreeLineChart && this.degreeLineChart.dispose();
      this.degreeLineChart = null;
      this.runFrequencyLoading = true;
      this.$http
        .post(this.$apiConfig.get_monthly_run_frequency, [this.liftInfo.jobNum])
        .then((response) => {
          let result = response.data;
          this.runFrequencyLoading = false;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          if (data.length == 0) return false;
          let dictionaries = {
            偏低: 0,
            正常: 1,
            偏高: 2,
          };
          this.runFrequencyData = data.map((v) => {
            return {
              ...v,
              level: dictionaries[v.frequency],
            };
          });
          this.setRunDegreeLine();
        })
        .catch((error) => {
          this.runFrequencyLoading = false;
          this.$sentry.captureException(error);
        });
    },
    //获取单梯数据
    getElevatorForBigScreen(jobNum) {
      this.$pageLoading(true);
      this.$http
        .get(this.$apiConfig.get_elevator_for_big_screen, {
          params: { jobNum },
        })
        .then((response) => {
          let result = response.data;
          this.$pageLoading(false);
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          this.setLiftInfoData(data);
          this.showInput = false;
        })
        .catch((error) => {
          this.$pageLoading(false);
          this.$sentry.captureException(error);
        });
    },
    //获取保养记录
    getMainPlanRecord() {
      this.mainPlanRecord = this.$options.data()["mainPlanRecord"];
      const { jobNum } = this.liftInfo;
      this.$http
        .get(this.$apiConfig.get_last_next_main, { params: { jobNum } })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          data.last = data.last || {};
          data.next = data.next || {};
          const { actualStartDt } = data.last;
          const { planStartDt } = data.next;
          if (actualStartDt) {
            data.last.actualStartDt = dayjs(actualStartDt).format("YYYY-MM-DD");
          }
          if (planStartDt) {
            data.next.planStartDt = dayjs(planStartDt).format("YYYY-MM-DD");
          }
          this.mainPlanRecord = data;
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    //获取图片列表
    getImageIdInfos() {
      this.mainPlanImageIds = [];
      this.previewImgList = [];
      const { mpId } = this.mainPlanRecord.last;
      if (!mpId) return;
      this.$http
        .get(this.$apiConfig.get_main_image_list_url, { params: { mpId } })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          const { list } = data.rtnData;
          this.mainPlanImageIds = list.filter((v) => v.attach_type == 3);
          if (this.mainPlanImageIds.length == 0) {
            return this.$message("暂无图片");
          }
          this.previewImgList.length = this.mainPlanImageIds.length;
          this.getImageData(0);
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    //获取图片详情
    getImageData(i) {
      this.preIniIndex = i;
      this.showViewer = true;
      if (this.previewImgList[i]) return;
      const { attach_id } = this.mainPlanImageIds[i];
      this.imgLoading = true;
      this.$http
        .get(this.$apiConfig.get_main_image_url, {
          params: {
            attachId: attach_id,
            attachType: 3,
          },
        })
        .then((response) => {
          let result = response.data;
          this.imgLoading = false;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          const { attach_base64 } = data.rtnData;
          this.$set(
            this.previewImgList,
            i,
            "data:image/jpg;base64," + attach_base64,
          );
        })
        .catch((error) => {
          this.imgLoading = false;
          this.$sentry.captureException(error);
        });
    },
    closeViewer() {
      this.showViewer = false;
    },
    switchViewer(i) {
      this.getImageData(i);
    },
    getVideoUrlToken() {
      this.videoPlayer && this.videoPlayer.stop();
      this.videoPlayerKey = Date.now();
      this.videoPlayer = null;
      this.videoUrl = null;
      this.videoToken = null;
      if (!this.liftInfo.deviceSerial) return;
      this.videoLoading = true;
      this.$http
        .post(this.$apiConfig.get_elevator_video_path_url, {
          quality: 2,
          type: 1,
          protocol: 4,
          deviceSerial: this.liftInfo.deviceSerial,
        })
        .then((response) => {
          let result = response.data;
          this.videoLoading = false;
          if (result.code != 0) return console.error(result.msg);
          this.videoUrl = result.data.url;
          this.videoToken = result.data.accessToken;
          // this.setVideoPlay(this.videoToken, this.videoUrl);
        })
        .catch((error) => {
          this.videoLoading = false;
          this.$sentry.captureException(error);
        });
    },
    setVideoPlay(accessToken, url, resize) {
      const el = document.getElementById("video-play-box");
      if (!el) return false;
      const width = el.offsetWidth - 2;
      const height = el.offsetHeight + 32;
      if (resize) {
        if (!this.videoPlayer) return;
        this.videoPlayer && this.videoPlayer.stop();
        this.videoPlayerKey = Date.now();
        this.$nextTick(() => {
          this.setVideoPlay(accessToken, url);
        });
        return;
      }
      this.videoPlayer = new EZUIKit.EZUIKitPlayer({
        id: "play-box-id",
        accessToken,
        url: url,
        template: "pcLive",
        width,
        height,
      });
      // this.$nextTick(() => {
      //   const elPlayId = document.getElementById("play-box-id");
      //   const elPlayWrap = document.getElementById("play-box-id-wrap");
      //   const elIdcanvas0 = document.getElementById("play-box-idcanvas0");
      //   const elIdcanvas_draw0 = document.getElementById(
      //     "play-box-idcanvas_draw0"
      //   );
      //   const div = document.getElementsByClassName("play-box-idparent-wnd")[0]
      //     .childNodes[0];
      //   [elPlayId, elPlayWrap, div, elIdcanvas0, elIdcanvas_draw0].forEach(
      //     (t) => {
      //       if (t) {
      //         t.style.height = "100%";
      //         t.style.width = "100%";
      //       }
      //     }
      //   );
      // });
    },
    initVideo() {
      if (!this.videoPlayer) {
        this.videoPlayer = new window.Jessibuca(
          {
            container: document.getElementById("video-play-box"),
            decoder: "/jessibuca/decoder.js",
            videoBuffer: 0.2, // 缓存时长
            isResize: false,
            text: "",
            loadingText: "加载中",
            debug: false,
            supportDblclickFullscreen: true,
            showBandwidth: false, // 显示网速
            operateBtns: {
              fullscreen: false,
              play: false,
              audio: false,
            },
            forceNoOffscreen: true,
            isNotMute: false,
          },
          {},
        );
      }
    },
    playElevatorVideo() {
      if (this.videoPlayer) {
        this.videoPlayer.destroy();
        this.videoPlayer = null;
      }
      this.$nextTick(() => {
        // this.initVideo();
        let paramData = {
          deviceSerial: this.liftInfo.deviceSerial,
          type: 1,
          quality: 1,
          protocol: 4,
          expireTime: 300,
          deviceType: this.liftInfo.deviceType,
          jobNum: this.liftInfo.jobNum,
          channelNo: this.liftInfo.channelNo ? this.liftInfo.channelNo : 1,
          pageInfo: "PC端-电梯AI运行诊断大屏-视频监控",
        };
        this.videoLoading = true;
        this.$http
          .post(this.$apiConfig.get_elevator_video_path_url, paramData)
          .then((response) => {
            let result = response.data;
            if (result.code == 0) {
              // this.videoPlayer.play(result.data.url);
              this.videoPlayer = new window.EzuikitFlv({
                url: result.data.url,
                container: document.getElementById("video-play-box"),
                decoder: "../../ezuikit-flv/decoder.js",
              });
              this.videoPlayer.on("error", (error) => {
                this.videoLoading = true;
              });
              this.videoPlayer.on("play", (info) => {
                this.videoLoading = false;
                document.getElementById("video-play-box").style.background =
                  "black";
              });
              this.videoPlayer.play();
            } else {
              this.videoLoading = false;
              this.videoPlayer = null;
            }
          })
          .catch((error) => {
            this.videoLoading = false;
            this.$sentry.captureException(error);
          });
      });
    },
    flvPlay() {
      if (!flvjs.isSupported()) {
        this.message(1, "浏览器不支持播放flv");
        return;
      }
      this.$nextTick(() => {
        this.videoLoading = true;
        this.$http
          .get(this.$apiConfig.get_iot_video_url, {
            params: {
              jobNum: this.liftInfo.jobNum,
              pageInfo: "PC端-电梯AI运行诊断大屏-视频监控",
            },
          })
          .then((response) => {
            this.videoLoading = false;
            let result = response.data;
            if (result.code == 0) {
              this.videoPlayer = flvjs.createPlayer(
                {
                  type: "flv",
                  url: result.data.url,
                  isLive: true,
                  hasAudio: false,
                  hasVideo: true,
                  enableStashBuffer: false,
                },
                {
                  enableWorker: false,
                  enableStashBuffer: false,
                  autoCleanupSourceBuffer: true,
                },
              );
              this.videoPlayer.attachMediaElement(
                document.getElementById("video"),
              );
              this.videoPlayer.load();
              this.videoPlayer.play();
              this.videoPlayer.on(
                flvjs.Events.ERROR,
                (errorType, errorDetail) => {
                  console.error(errorType, errorDetail);
                },
              );
            }
          })
          .catch((error) => {
            this.videoLoading = false;
            console.log(error);
            this.$sentry.captureException(error);
          });
      });
    },
    fullscreen() {
      if (this.videoPlayer) {
        if (this.videoPlayer.getState().fullscreen) {
          this.videoPlayer.cancelFullScreen();
        } else {
          this.videoPlayer.fullScreen();
        }
      }
    },
    //获取最近维修记录
    getLastFaultRecord() {
      this.faultRecord = this.$options.data()["faultRecord"];
      const { jobNum } = this.liftInfo;
      this.$http
        .get(this.$apiConfig.get_last_fault_record, { params: { jobNum } })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          const data = result.data;
          const { date, days } = data;
          if (date) {
            this.faultRecord.text = this.$l("电梯近30天内故障维修日期：");
            this.faultRecord.date = date;
          } else if (days) {
            this.faultRecord.text = `${this.$l("电梯")} ${
              days + this.$l("天内无出现故障维修，整体运行良好。")
            }`;
          } else
            this.faultRecord.text =
              this.$l("电梯从未出现故障维修，整体运行良好。");
        })
        .catch((error) => {
          console.log(error);
          this.$sentry.captureException(error);
        });
    },
    //获取部件寿命
    getComponentLifePrediction() {
      this.componentLifes = [];
      this.componentLifeLoading = true;
      const { jobNum: elevator_code } = this.liftInfo;
      this.$http
        .post(this.$apiConfig.get_component_life_prediction, { elevator_code })
        .then((response) => {
          let result = response.data;
          this.componentLifeLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          if (this.liftInfo.elevatorAge <= 2) data = [];
          if (data.length > 5) data.length = 5;
          this.componentLifes = data;
        })
        .catch((error) => {
          this.componentLifeLoading = false;
          this.$sentry.captureException(error);
        });
    },
    //获取运行质量
    getRunQualityIndex() {
      this.runQualityData = [];
      this.runQualityGrade = this.$options.data()["runQualityGrade"];
      this.qualityRadarChart && this.qualityRadarChart.dispose();
      this.qualityRadarChart = null;
      const { jobNum } = this.liftInfo;
      this.runQualityLoading = true;
      this.$http
        .get(this.$apiConfig.get_run_quality_index, { params: { jobNum } })
        .then((response) => {
          let result = response.data;
          this.runQualityLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          const { dimensions, remark, score } = data;
          this.runQualityData = dimensions;
          this.runQualityGrade = { remark, score };
          this.$nextTick(() => {
            this.setRunQualityRadar();
          });
        })
        .catch((error) => {
          this.runQualityLoading = false;
          this.$sentry.captureException(error);
        });
    },
    //销毁单梯页面图表
    destroySingleLiftChart() {
      this.qualityRadarChart && this.qualityRadarChart.dispose();
      this.degreeLineChart && this.degreeLineChart.dispose();
      if (this.mapExample) this.mapKey = Date.now();
      this.qualityRadarChart = null;
      this.degreeLineChart = null;
      this.mapExample = null;
      this.videoPlayer && this.videoPlayer.stop();
      this.videoPlayerKey = Date.now();
      this.videoPlayer = null;
      this.doorClass = "";
      this.doorState = "";
    },
    breakMoreLiftRealData() {
      this.moreInfoStatusList = [];
      if (this.$store.state.ws) {
        this.$store.state.isAutoCloseWS = false;
        this.$store.state.ws.close();
        this.$store.commit("setWS", null);
      }
    },
    moreLiftRealData(list) {
      this.realMonitorBigScreen(list, false, (d) => {
        const data = JSON.parse(d);
        data.forEach((item, index) => {
          if (!item.data || JSON.stringify(item.data) == "{}") return;
          let canFaultStatus = item.data.FaultStatus.filter((v) =>
            this.hasMonitorFieldPermission("fault#" + v.name),
          );
          let canRunStatus = item.data.RunStatus.filter((v) =>
            this.hasMonitorFieldPermission("run#" + v.name),
          );
          let canOtherStatus = item.data.OtherStatus.filter((v) =>
            this.hasMonitorFieldPermission("other#" + v.name),
          );
          this.$set(this.moreInfoStatusList, index, {
            infoData: Object.assign(item, { data: null }),
            runStatus: {
              faultStatus: canFaultStatus,
              runStatus: canRunStatus,
              otherStatus: canOtherStatus,
            },
          });
        });
      });
    },
    liftSelected(list) {
      if (list.length == 0) return false;
      this.breakMoreLiftRealData();
      if (list.length == 1) {
        this.isMoreLift = false;
        sessionStorage.setItem("deviceBigScreenLift", JSON.stringify(list[0]));
        return this.setLiftInfoData(list[0]);
      }
      this.isMoreLift = true;
      this.destroySingleLiftChart();
      this.moreInfoStatusList = list.map((v) => {
        return {
          infoData: { ...v },
          runStatus: {
            faultStatus: [],
            runStatus: [],
            otherStatus: [],
          },
        };
      });
      this.moreLiftRealData(list);
    },
    entranceLift(data) {
      const { infoData, runStatus } = data;
      this.liftSelected([{ ...infoData }]);
    },
    //开关门
    playDoorAnimation(type, resize) {
      console.log("type", type);
      const isEscalator = this.liftInfo.elevatorType != "直梯";
      if (!!this.keyFrames && !type) {
        this.keyFrames.destroy();
      }
      const f = this.keyFrames;
      this.keyFrames = null;
      let count = 0;
      let num = 0;
      if (type == "close") {
        num = 10;
      }
      if (this.isMoreLift) return console.log("moreLift-return");
      const FrameImgArr = [];
      const initKeyFrames = (imgArr) => {
        // console.log(imgArr);
        let doc = document.querySelector(
          isEscalator ? ".lift-escalator-box" : ".lift-run-area",
        );
        this.keyFrames = new CanvasKeyFrames(doc, "array", imgArr, {
          fps: 10,
          loop: isEscalator ? "infinite" : 1,
        });
        if (f) f.destroy(); //防止闪烁
        if (resize && !isEscalator) this.keyFrames.goto(imgArr.length - 1);
        else this.keyFrames.play();
      };
      const createImg = (i) => {
        let img = new Image();
        img.onload = function () {
          img.onload = null;
          count++;
          FrameImgArr[i] = img;
          if (isEscalator && count == 7) {
            initKeyFrames(FrameImgArr);
          }
          if (count == 10) {
            initKeyFrames(FrameImgArr);
          }
          if (!type) {
            initKeyFrames(FrameImgArr);
          }
        };
        img.onerror = function (err) {
          console.log(err);
        };
        if (isEscalator) {
          img.src = require(`../../assets/img/largeScreen/animation/扶梯${
            type == "close" ? i + 1 : 6 - i + 1
          }.png`);
        } else {
          img.src = require(`../../assets/img/largeScreen/animation/电梯动画${
            i + 1 + num
          }.png`);
        }
      };
      if (!type) {
        num = 19;
        createImg(0);
        return;
      }
      let len = 10;
      if (isEscalator) len = 7;
      for (let i = 0; i < len; i++) {
        createImg(i);
      }
    },
    allowMonitor() {
      if (this.$store.state.user.monitor) {
        if (
          !this.$store.state.allDayMonitorTimer &&
          this.$store.state.allDayMonitorTimer != -1
        ) {
          this.$store.state.allDayMonitorTimer = window.setTimeout(() => {
            this.$http
              .get(this.$apiConfig.allow_all_day_monitor_url)
              .then((response) => {
                if (this.$store.state.allDayMonitorTimer != -1) {
                  this.$store.state.allDayMonitorTimer = null;
                  this.allowMonitor();
                }
              })
              .catch((error) => {
                this.allowMonitor();
              });
          }, 300000);
        }
      }
    },
  },
  beforeDestroy() {
    if (
      this.$store.state.allDayMonitorTimer &&
      this.$store.state.allDayMonitorTimer != -1
    ) {
      window.clearTimeout(this.$store.state.allDayMonitorTimer);
    }
    this.$store.state.allDayMonitorTimer = -1;
    if (this.$store.state.ws) {
      this.$store.state.isAutoCloseWS = false;
      this.$store.state.ws.close();
      this.$store.commit("setWS", null);
    }
    this.breakLiftRealData();
    this.breakMoreLiftRealData();
  },
};
</script>

<style scoped lang="scss">
.tip {
  min-width: 180px;
  width: vw(180);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    text-align: right;
    width: 100%;
    position: relative;
    font-size: 1.125rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 500;
    font-style: italic;
    color: #d1d6df;
    padding-bottom: 10px;
    background: linear-gradient(0deg, #acddff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    // text-shadow: 1px 1px 1px #ddd;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../../assets/img/largeScreen/largeScreenTip.png) no-repeat;
    }
  }
}
.tip-plus {
  width: 100%;
  p {
    text-align: left;
    padding-left: 20px;
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipPlus.png);
  }
}
.tip-plus-bottom {
  width: 100% !important;
  p {
    height: vh(40);
    text-align: left;
    padding-left: 40px;
    line-height: 40px;
    padding-bottom: 0;
    font-family: AlibabaPuHuiTi;
    font-size: 1.5rem;
    font-weight: 700;
    font-style: italic;
    color: #f6f9fe;
    background-image: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipLBootom.png);
  }
}
/* / */
.tip-right {
  p {
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  span {
    float: right;
    font-size: 0.875rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #b5c5d4;
    font-style: normal;
  }
}
.screen-main {
  flex: 1;
  min-height: 10px;
  position: relative;
  // background: url(../../assets/img/largeScreen/deviceBigScreenBgc.jpg) no-repeat;
  // background-size: 100% 100%;
  display: flex;
  padding: vh(18) vw(20) vh(10) vw(20);
  gap: vw(20);
  overflow: hidden;
}
.main-left,
.main-right {
  width: vw(434);
  min-width: 410px;
  border-radius: 8px 8px 0 0;
  // background-color: rgba(5, 25, 53, 0.6);
  display: flex;
  flex-direction: column;
}
.main-left {
  // padding: vh(15) vw(32) vh(20) vw(15);
}
.main-right {
  min-width: 350px;
  // padding: vh(15) vw(15) vh(20) vw(15);
}
.main-center {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.lift-status-info {
  display: flex;
  flex-direction: column;
  width: vw(310);
  margin: vh(120) vw(60) 0;
}

.lift-status-info-title {
  .title-tips {
    line-height: vh(48);
    margin-bottom: vh(16);
    color: var(--bs-color-text-secondary);
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(#7b96eb, 0.5);
  }
  h4 {
    position: relative;
    font-size: 1.5rem;
    line-height: 1.5;
    // font-family: JiangChengXieHei;
    font-weight: bold;
    color: #ffffff;
    padding-left: vw(44);
    display: flex;
    align-items: center;
    // justify-content: center;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0.1em;
      width: vw(32);
      height: vw(32);
      background: url(../../assets/img/largeScreen/location.png) no-repeat;
      background-size: 100% 100%;
      z-index: 3;
    }
  }
  p {
    padding-left: vw(44);
    margin-top: vh(24);
    color: var(--bs-color-text-regular);
    font-size: 0.875rem;
    text-shadow: 0 0 0.5em rgba(0, 0, 0, 0.8);
    span {
      margin-left: 0.5em;
      font-weight: bold;
      font-size: 1.125rem;
    }
  }
}

.searchBtn {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 3;
  i {
    width: vh(25);
    height: vh(25);
    background: url(../../assets/img/largeScreen/search.png) no-repeat;
    background-size: 100% 100%;
    margin-left: vw(15);
    cursor: pointer;
  }
  /deep/.el-input {
    flex: 1;
    max-width: vw(160);
    line-height: 0;
    .el-input__inner {
      height: auto;
      line-height: 0;
      border-radius: 0;
      background-color: transparent;
      border: 0;
      caret-color: #fff;
      color: #f7faff;
      font-size: 0.9375rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      &::placeholder {
        font-size: 0.9375rem;
      }
    }
  }
}

.title-bgc-list-box {
  margin-top: vh(40);
  position: relative;
  background-image: linear-gradient(
    180deg,
    rgba(12, 16, 31, 0.6) 0%,
    rgba(43, 52, 102, 0.75) 100%  );
  box-shadow: 0 vw(8) vh(12) 0 rgba(56, 99, 233, 0.15);
  border-radius: vw(8);
  &:before {
    content: "";
    position: absolute;
    z-index: 2;
    pointer-events: none;
    inset: 0;
    border-radius: vw(8);

    padding: 1px;
    background: rgba(224, 245, 255, 0.3);
    background: linear-gradient(
      135deg,
      rgba(#7698ff, 1) 0%,
      rgba(#394691, 1) 40%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  .list {
    padding: vw(2) vw(16);
    & > div {
      display: flex;
      justify-content: space-between;
      padding: vh(6) 0;
      border-bottom: 1px solid rgba(141, 184, 216, 0.23);
      font-size: 0.8125rem;
      font-family: AlibabaPuHuiTi;
      &:last-child {
        border-bottom: none;
      }
      &:nth-child(2n-1) {
        // background: #000815;
      }
      &:nth-child(2n) {
        // background: #111d2c;
      }
      label {
        color: var(--bs-color-text-regular);
        position: relative;
        z-index: 3;
      }
      span {
        color: var(--bs-color-text-primary);
        position: relative;
        z-index: 3;
      }
    }
    .not-normal {
      color: var(--bs-color-danger);
    }
    .normal {
      color: var(--bs-color-success);
    }
    .speed {
      color: var(--bs-color-warning);
    }
    .suggest {
      color: #f5664a;
      font-size: 0.75rem;
    }
  }
}

.video-monitoring {
  flex: 1;
  margin-top: vh(15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .play-box {
    width: 95%;
    margin: 0 auto;
    position: relative;
    flex: 1;
    // height: vh(240);
    border: 1px solid #3366cd73;
    overflow: hidden;
    video {
      height: 100%;
    }
  }
  #play-box-id {
    height: 100%;
    width: 100%;
  }

  .lar-change {
    // position: relative;
    // z-index: 999;
    // margin-right: 20px;
    .svg-icon {
      cursor: pointer;
      width: vh(20);
      height: vh(20);
    }
  }
}
.recently-service {
  margin-top: vh(15);
  height: vh(119);
}
.ranking-list {
  width: 95%;
  margin: 0 auto;
  border-top: 1px solid transparent;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    height: 1px;
    width: 100%;
    top: 0;
    background: linear-gradient(
      90deg,
      #2d537700 0%,
      #426bc6d1 30%,
      #2d537700 100%
    );
  }
  & > div {
    height: vh(35);
    display: flex;
    align-items: center;
    font-family: AlibabaPuHuiTi;
    color: var(--bs-color-text-regular);
    padding: 0 vw(10);
    border-bottom: 1px solid #1c3055;
    &:nth-child(2n-1) {
      background-color: rgba(10, 16, 61, 0.5);
    }
    &:nth-child(2n) {
      background-color: rgba(40, 63, 131, 0.35);
    }
    span {
      font-size: 0.875rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
    }
  }
  .list-title {
    // color: var(--bs-color-text-primary);
    color: #acbbf6;
    font-size: 0.875rem;
    // font-weight: 500;
    .svg-icon {
      width: vw(18);
      height: vw(18);
      margin-left: 4px;
      color: var(--bs-color-info);
    }
    .div-els {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .view-img {
    color: var(--bs-color-info);
    cursor: pointer;
  }
}

.list-table {
  font-size: 0.875rem;
  .table-row {
    display: flex;
    padding: 0;
    & > div {
      padding: 0 vw(1);
      height: 100%;
      text-align: center;
      line-height: vh(35);
      border-right: 1px solid #1c3055;
      &:last-child {
        border: 0;
      }
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .level-S {
    color: var(--bs-color-warning);
  }
  .level-A {
    color: var(--bs-color-em);
  }
}
.row-n-1-n-1 {
  & > div > div:nth-child(1) {
    width: vw(52);
  }
  & > div > div:nth-child(2) {
    flex: 1;
  }
  // & > div > div:nth-child(3) {
  //   width: vw(75);
  // }
  & > div > div:nth-child(3) {
    flex: 1;
  }
  & > div > div:nth-child(4) {
    width: vw(90);
  }
}
.row-1-1-n-1 {
  // width: vw(418);
  // width: 95%;
  & > div > div:nth-child(3) {
    flex: 1;
  }
  & > div > div:nth-child(1) {
    width: vw(100);
  }
  & > div > div:nth-child(2) {
    width: vw(80);
  }
  & > div > div:nth-child(4) {
    width: vw(80);
  }
}
.run-quality-index {
  .quality-view-box {
    position: relative;
    height: vh(160);
    display: flex;
    align-items: center;
    padding-right: vw(20);
  }
  .quality-index-box {
    height: 100%;
    flex: 0.6;
    flex-basis: 0;
  }
  .quality-grade-box {
    flex: 0.4;
    margin-top: vh(24);
    display: flex;
    flex-direction: column;
    align-items: center;
    .circle-box {
      width: vh(80);
      height: vh(80);
      position: relative;
      &::before {
        content: "";
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        width: vh(100);
        height: vh(100);
        background: url(../../assets/img/largeScreen/largeScreenProgressBgc.png)
          no-repeat;
        background-size: 100%;
      }
    }
    span {
      font-family: DINCond-Bold;
      font-weight: 400;
      color: #95d8ff;
      font-size: 1.5rem;
    }
    i {
      margin-top: vh(15);
      font-size: 1.3125rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 500;
      // color: var(--bs-color-em);
      color: var(--bs-color-text-primary);
      font-style: normal;
      text-shadow: 0 0 0.5em #3863e9;
    }
  }
}
.run-degree-line {
  margin-top: vh(10);
  .degree-line-box {
    height: vh(175);
    position: relative;
  }
  #run-degree-id {
    height: 100%;
  }
  .custom-legend-box {
    position: absolute;
    // width: calc(100% - (2% + 46px));
    top: vh(6);
    left: 0;
    right: 0;
    // right: 5%;
    font-size: 0.8125rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: var(--bs-color-text-regular);
    display: flex;
    justify-content: space-around;
    div {
      display: flex;
      justify-content: center;
    }
    i {
      display: inline-block;
      width: vw(12);
      height: vh(8);
      min-width: 12px;
      min-height: 8px;
      background: #8ae4ef;
      margin-right: 5px;
    }
    span[data-color="1"] i {
      background: #87b9ff;
    }
    span[data-color="2"] i {
      background: #fb5c5d;
    }
  }
}
.lift-nearby-crew {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: vh(10);
  .location-map {
    width: 95%;
    margin: 0 auto;
    flex: 1;
    border: 1px solid #3366cd73;
    position: relative;
  }
  #location-map-box {
    width: 100%;
    height: 100%;
  }
  .crew-list {
    position: absolute;
    right: 0;
    top: vh(10);
    right: vh(10);
    background-color: #294a9aeb;
    display: flex;
    flex-direction: column;
    border-left: 3px solid #74edf2;
    div {
      display: flex;
      flex-direction: column;
      font-size: 0.875rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #bcd3df;
      padding: vh(5) vh(10);
      border-bottom: 2px solid #1b66b7;
      &:last-child {
        border: 0;
      }
      em {
        color: #74edf2;
      }
    }
  }
}
.units-lifetime-forecast {
  margin-top: vh(10);
}
/deep/.BMap_cpyCtrl,
/deep/.anchorBL {
  display: none;
}
.maintenance-record {
  display: flex;
  & > div {
    flex: 0.5;
    padding: vh(10) vw(20) vh(0) vw(20);
  }
}
.lift-view-box {
  flex: 1;
  display: flex;
  .lift-run-area {
    position: relative;
    flex: 1;
    // background: url(../../assets/img/largeScreen/verticalLift.png) no-repeat;
    // background-position: right center;
    // background-size: contain;
  }
  .none-class {
    // background: none !important;
  }

  .lift-escalator-box {
    position: relative;
    flex: 1;
    // background: url(../../assets/img/largeScreen/escalator.png) no-repeat;
    // background-position: right center;
    // background-size: contain;
  }
}
.btn-direction {
  position: absolute;
  z-index: 5;
  position: absolute;
  right: 6%;
  top: 25%;
  width: vw(94);
  height: vw(94);
}
.direction-below {
  background: url(../../assets/img/largeScreen/liftBelowBtn.png) no-repeat;
  background-size: contain;
  animation: floor 1.5s linear infinite normal;
}
.direction-up {
  background: url(../../assets/img/largeScreen/liftUpBtn.png) no-repeat;
  background-size: contain;
  animation: floor 1.5s linear infinite normal;
}
.escalator-locf-fault {
  z-index: 5;
  position: absolute;
  width: vw(113);
  height: vh(107);
  background: url(../../assets/img/largeScreen/faultIcon.png) no-repeat;
  background-size: contain;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: locf-flicker 1.5s linear infinite normal;
}
.escalator-fault-text {
  z-index: 5;
  position: absolute;
  right: 6%;
  bottom: 35%;
}

.lift-run-fault-info {
  // flex: 0.4;
  // padding: 0 vw(42) 0 vw(32);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: vh(15);
}

.run-status-box {
  $run-color: #8ae4ef;
  $fault-color: #fb5c5d;
  // width: vw(415);
  max-height: vh(245);
  min-height: vh(235);
  display: flex;
  flex-direction: column;

  .status-list {
    flex: 1;
    min-height: 10px;
    // border-top: 1px solid rgba(216, 227, 238, 0.1);
    overflow-y: auto;
    @extend %scroll-bs;
    .row-item {
      width: 95%;
      margin: 0 auto;
      height: vh(35);
      line-height: vh(35);
      display: flex;
      border-bottom: 1px solid rgba(216, 227, 238, 0.1);
      &:nth-child(2n-1) {
        background-color: rgba(34, 50, 105, 0.5);
      }
      div {
        display: flex;
        align-items: center;
        width: 33.33%;
        font-size: 0.875rem;
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: var(--bs-color-text-regular);
        padding: 0 vw(10);
        border-right: 1px solid rgba(216, 227, 238, 0.1);
        &:last-child {
          border: 0;
        }
      }
    }
    i {
      display: inline-block;
      height: vh(14);
      width: vh(14);
      background-color: #89b7ff29;
      border-radius: 50%;
      margin-right: vw(10);
    }
    span {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .activate-run,
    .activate-fault {
      span {
        color: var(--bs-color-text-primary);
        // color: $run-color;
        font-size: 1rem;
        font-weight: 500;
      }
      i {
        background-color: $run-color;
        border: 1px solid rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 vw(4) 2px rgba($run-color, 0.5);
        position: relative;
        // &::before {
        //   position: absolute;
        //   content: "";
        //   width: vh(7);
        //   height: vh(7);
        //   top: 50%;
        //   left: 50%;
        //   transform: translate(-50%, -50%);
        //   background-color: $run-color;
        //   border-radius: 50%;
        // }
      }
    }

    .activate-fault i {
      background-color: $fault-color;
      box-shadow: 0 0 vw(4) 2px rgba($fault-color, 0.5);
    }
    .activate-fault span {
      color: $fault-color;
    }
  }
  .run-red i {
    background-color: rgba($fault-color, 0.5);
    box-shadow: none;
  }
}
.locf-door {
  position: absolute;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../../assets/img/largeScreen/verticalLift2.png) no-repeat;
  background-position: right center;
  background-size: contain;
  animation: locf-flicker 1.5s linear infinite normal;
}
.locf-fault {
  position: absolute;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../../assets/img/largeScreen/verticalLift3.png) no-repeat;
  background-position: right center;
  background-size: contain;
  animation: locf-flicker 1.5s linear infinite normal;
}
/* / */
.tiring,
.warning {
  height: vh(36);
  display: flex;
  border-radius: 4px;
  background: #000a20;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    z-index: 0;
    inset: 0;
    border-radius: 4px;
  }
  span {
    width: vh(38);
    border-radius: 4px;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  label {
    flex: 1;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 500;
    color: #fffefd;
    position: relative;
    padding: 0 vw(10);
  }
}
.tiring {
  span {
    background-color: #f1bc66;
  }
  &::after {
    background-image: linear-gradient(
      90deg,
      rgba(#ffce7f, 0.5) 0%,
      transparent 100%
    );
  }
  .svg-icon {
    width: 100%;
    height: 100%;
    fill: #ffffff;
  }
  margin-bottom: vh(24);
}
.warning {
  span {
    background-color: #ff3d3d;
  }
  &::after {
    background-image: linear-gradient(
      90deg,
      rgba(#ff3d3d, 0.5) 0%,
      transparent 100%
    );
  }
  .svg-icon {
    width: 68%;
    height: 68%;
    fill: #ffffff;
  }
}
.text-fault {
  z-index: 5;
  position: absolute;
  right: 15%;
  top: 35%;
}
.text-unusual {
  z-index: 5;
  position: absolute;
  right: 5%;
  bottom: 25%;
}
.text-door {
  z-index: 5;
  position: absolute;
  right: 5%;
  // transform: translateX(100%);
  bottom: 5%;
}
@keyframes locf-flicker {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes floor {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
.btn-floor-box {
  z-index: 5;
  position: absolute;
  left: 6%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  .direction {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: vh(20) 0;
    &::before,
    &::after {
      content: "";
      display: block;
      width: vw(94);
      height: vw(94);
      background: url(../../assets/img/largeScreen/liftUpBtn.png) no-repeat;
      background-size: contain;
      opacity: 0.3;
    }
    &::after {
      background-image: url(../../assets/img/largeScreen/liftBelowBtn.png);
    }
    span {
      height: vh(80);
      // line-height: vh(80);
    }
  }
  .floor-up::before {
    animation: floor 1.5s linear infinite normal;
  }
  .floor-below::after {
    animation: floor 1.5s linear infinite normal;
  }
  span {
    font-size: 3rem;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #c5dfef;
    background: linear-gradient(0deg, #acd0ff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .weight {
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 1.25rem;
    }
  }
}
.thermometer-box {
  position: absolute;
  z-index: 5;
  top: 20%;
  right: 40%;
  transform: translateX(50%);
  font-size: 1.125rem;
  font-family: AlibabaPuHuiTi;
  font-weight: 500;
  font-style: normal;
  color: #f9c62d;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10em;
  padding: 0 1em;
  display: flex;
  align-items: center;
  .svg-icon {
    fill: #f9c62d;
    width: vw(40);
    height: vw(40);
  }
}
.not-data {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: AlibabaPuHuiTi;
  font-weight: 400;
  font-style: normal;
  font-size: 0.875rem;
  color: #b9ccdf;
}
.not-data-position {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
/deep/.el-icon-circle-close {
  color: #fff;
}
/deep/#play-box-id-headControl {
  display: none !important;
}
/deep/ #play-box-id-audioControls-left {
  .theme-icon-item:nth-child(2) {
    display: none;
  }
  .theme-icon-item:nth-child(4) {
    display: none;
  }
  .theme-icon-item:nth-child(5) {
    display: none;
  }
  .theme-icon-item:nth-child(6) {
    display: none;
  }
  .theme-icon-item:nth-child(7) {
    display: none;
  }
}
/deep/ #play-box-id-audioControls-right {
  .theme-icon-item:nth-child(1) {
    display: none;
  }
  .theme-icon-item:nth-child(2) {
    display: none;
  }
  .theme-icon-item:nth-child(3) {
    display: none;
  }
}
.component-life-list {
  width: 100%;
  min-height: vh(105);
  & > div {
    width: 100% !important;
  }
}
.more-lift-box {
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background: rgba(5, 25, 53, 0.3);
  border-radius: 6px;
  padding: vh(30) vw(15);
}
</style>
<style lang="scss">
.units-explain.el-tooltip__popper.is-dark {
  background-color: rgba(33, 51, 112, 0.9);
  font-size: 0.75rem;
  line-height: 1.5;
}
.units-explain.el-tooltip__popper[x-placement^="top"] .popper__arrow:after,
.units-explain.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: rgba(33, 51, 112, 0.9);
  opacity: 0.5;
}
.p-change {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.screenStyle {
  .el-dialog__header {
    .el-dialog__title {
      position: relative;
      font-family: AlibabaPuHuiTi;
      font-weight: 500;
      color: #fff;
      padding-bottom: 10px;
      background: -webkit-gradient(
        linear,
        left bottom,
        left top,
        from(#acbdff),
        to(#ffffff)
      );
      background: linear-gradient(0deg, #acbdff 0%, #ffffff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .el-dialog__close {
      color: var(--bs-color-text-secondary);
    }
  }
  .el-loading-mask {
    background-color: rgba(5, 15, 53, 0.9);
    .el-loading-spinner .path {
      stroke: #5b7fd4;
    }
  }
  .el-dialog {
    background-color: rgba(20, 23, 49, 0.8);
    box-shadow: inset 0 0 vw(30) rgba(30, 84, 231, 0.5);
    // .el-select .el-input.is-focus .el-input__inner {
    //   border-color: #2c6b8d;
    // }
    // .el-button--primary {
    //   color: #ffffff;
    //   background-color: #2474bb;
    //   border-color: #2474bb;
    // }
    // .el-button--default {
    //   color: #c8d2df;
    //   background-color: transparent;
    //   border-color: #154166;
    // }
    // .el-table {
    //   background: rgba(0, 0, 0, 0);
    // }
    // .el-select-dropdown {
    //   background-color: rgba(5, 25, 53, 1);
    //   border-color: rgba(5, 25, 53, 1);
    //   .popper__arrow {
    //     &::after {
    //       border-bottom-color: rgba(5, 25, 53, 1);
    //     }
    //     border-bottom-color: rgba(5, 25, 53, 1);
    //   }
    //   .hover {
    //     background-color: #51bbf6d1;
    //   }
    //   span {
    //     color: #fff;
    //   }
    // }
    // .el-input__inner {
    //   background-color: #0c4475;
    //   color: #c8d2df;
    //   border-color: #0c4475;
    //   &::placeholder {
    //     color: #c8d2df;
    //   }
    // }
    // .btn-prev,
    // .btn-next {
    //   background-color: rgba(5, 25, 53, 0.8);
    //   .el-icon {
    //     color: #49a5e2;
    //   }
    // }
    // .number,
    // .more {
    //   color: #c8d2df;
    //   background-color: rgba(5, 25, 53, 0);
    // }
    // .active {
    //   background-color: #2474bb;
    // }
    // .el-input__icon {
    //   color: #3381a5;
    // }
    // .el-pagination {
    //   span {
    //     color: #c8d2df;
    //   }
    //   .el-input__inner:hover {
    //     border-color: #0c4475;
    //   }
    // }
  }
  // .el-table {
  //   th {
  //     background: rgba(0, 0, 0, 0);
  //   }
  //   .el-checkbox {
  //     .el-checkbox__inner {
  //       background-color: #285a85;
  //       border-color: #3b80a5;
  //       color: #fff;
  //     }
  //   }
  //   &::before {
  //     width: 0;
  //   }
  //   .el-table__fixed-right::before {
  //     background-color: rgba(0, 0, 0, 0);
  //   }
  //   .el-table__fixed-right-patch {
  //     background-color: rgba(0, 0, 0, 0);
  //     border-color: rgba(0, 0, 0, 0);
  //   }
  //   .el-table__body-wrapper {
  //     @extend %scroll-bs;
  //   }
  //   tr:nth-child(2n-1) {
  //     background-color: #0a2c4f;
  //     td {
  //       background-color: #0a2c4f !important;
  //     }
  //   }
  //   .current-row td,
  //   .hover-row td {
  //     color: #fff;
  //     background-color: rgba(0, 0, 0, 0) !important;
  //   }
  //   th.is-leaf,
  //   td {
  //     border-bottom: 1px solid #5fb5ff3d;
  //     background-color: #0b3b63;
  //     color: #fff;
  //   }
  //   tr {
  //     background-color: #0d3f6a;
  //     td {
  //       color: #c8d2df;
  //       border-bottom: 1px solid #5fb5ff3d;
  //     }
  //   }
  // }
  .el-tag {
    background-color: #324f8f;
    border-color: #324f8f;
    color: #fff;
  }
  .el-tag .el-tag__close:hover {
    background-color: rgba(15, 25, 58, 0.4);
  }
  .el-tabs__item {
    color: #d1d6df;
  }
  .el-tabs__active-bar {
    background-color: #3863e9;
  }
  .el-tabs__nav-wrap::after {
    background-color: rgba(56, 99, 233, 0.25);
  }
  .el-tag__close {
    color: #fff !important;
  }
}
</style>
<style lang="scss">
.screenPage {
  background-color: rgba(5, 25, 53, 1);
  border-color: rgba(5, 25, 53, 1);
  .popper__arrow {
    &::after {
      border-bottom-color: rgba(5, 25, 53, 1);
    }
    border-bottom-color: rgba(5, 25, 53, 1);
  }
  .hover {
    background-color: #51bbf6d1;
  }
  span {
    color: #fff;
  }
}
</style>
